import { createAction, props } from '@ngrx/store';

export const loadPaymentDay = createAction('[PaymentDay] Load PaymentDays', props<{ request: { businessId: string } }>());

export const loadPaymentDaySuccess = createAction('[PaymentDay] Load PaymentDays Success', props<{ response: string }>());

export const loadPaymentDayFailure = createAction('[PaymentDay] Load PaymentDays Failure', props<{ error: Error | any }>());
